import React from 'react'
import Link from 'gatsby-link'

const SecondPage = () => (
  <div>
    <h1>About me</h1>
    <p>
      My name is Stevica Knezevic and I am a web developer who lives and breathes the code.
    </p>
    <p>
      As a true technology buff, I am always looking for new ways to improve my skills. But this is not an easy task
      since everything is moving at a fast pace.
      This is where love comes into play. Nothing makes me happier than building apps using JavaScript and other
      web-related technologies! I know it sounds like I’m exaggerating, but it’s true. Even reading about the latest
      technology developments can motivate me to create something I have never created before.
    </p>
    <p>
      Because of my desire to learn new things, I became interested in exploring technologies that are not strictly
      front-end related, such as Node frameworks (Hapi.js, Express.js), Socket.io, Docker and various services like AWS.
      This is just a small part of what I do, so if you want to find out more about this, you should check out my
      Portfolio page.
    </p>

    <h2>Work Experience:</h2>
    <h3>
      <a target={'_blank'} href="https://www.lambdaworks.io">
        Lambdaworks
      </a>{' '}
      - Full-Stack JavaScript Developer
    </h3>

    <p>
      Developing the PRM app using React, Redux, GraphQL, WebSocket, Express.js and Webpack
      consuming API service built in Scala.
    </p>


    <h3>
      <a target={'_blank'} href="https://brisqq.com/">
        Brisqq
      </a>{' '}
      - Full-Stack JavaScript Developer
    </h3>

    <p>
      Developing the app using React, Redux, Socket.io, Lodash, Semantic UI
      (consuming API service built in Hapi framework). Also I participate in
      discovery phase in order to apply serverless approach to our platform,
      using AWS services like Kinesis, Lambda, Elasticsearch.
    </p>

    <h3>
      <a target={'_blank'} href="https://www.etondigital.com/">
        EtonDigital
      </a>{' '}
      - JavaScript Developer
    </h3>
    <p>
      Developing the applications and social networks using Angular framework
      consuming API service built in Symfony as well as front-end implementation
      using Drupal CMS.
    </p>
    <p>
      As a Front-End developer I had the chance to work on challenging projects
      for brands such as Hyundai, Nissan, Savvy-Investor, Cytoo, TallyFox. My
      main responsibilities besides writing code were the selection of
      technologies for the given project and planning the application structure.
      I used modern frameworks and libraries like AngularJS, Angular 2,
      TypeScript, RxJS, jQuery, Underscore, Node.js, SASS/Compass, Twig, Drupal.
    </p>

    <h3>
      <a target={'_blank'} href="https://www.serviceplus-it.com/">
        Service Plus Group
      </a>{' '}
      - Application support
    </h3>
    <p>
      Working as application support using software for managing all activities on
      petrol stations, providing following activities: Software integration and
      data migration projects, pilot and field installations, transations
      troubleshooting, network monitoring, configuration of the forecourt
      controllers payment terminals (IPT, OPT), generating, export/import PK
      (private keys) on the HSM, for FST’s.
    </p>

    <h2>Social:</h2>
    <p>
      If you want to learn more about me, you can find me on:{' '}
      <a target={'_blank'} href="https://twitter.com/knezevic84">
        Twitter
      </a>,{' '}
      <a target={'_blank'} href="https://www.linkedin.com/in/stevicaknezevic/">
        Linkedin
      </a>,{' '}
      <a target={'_blank'} href="https://github.com/stevica">
        GitHub
      </a>{' '}
      and{' '}
      <a target={'_blank'} href="https://www.instagram.com/knezevicsteva/">
        Instagram
      </a>.
    </p>

    <h2>My spare time:</h2>
    <p>
      When I am not working or learning, I enjoy working out, having fun with my friends and traveling. I especially love to cook, because it relaxes me and keeps my mind off things.
      One day, I hope to fulfill one of my wishes to try Wingsuit flying.
    </p>

    <Link to="/">Go back to the homepage</Link>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/about.js